import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DownloadPdfExcelUsecase extends BaseUseCase {
    constructor(downloadRepo) {
        super();
        this.downloadRepo = downloadRepo;
    }
    async fetchResult(req) {
        return await this.downloadRepo.downloadRevampPdfExcel(req);
    }
}
export default DownloadPdfExcelUsecase;
